import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Text } from "@zillow/constellation-10";
import { omitUndefined } from "../../utils/lodash.esm.js";
import { commaSeparateNumber } from "../../utils/zhl-calculator.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import { FieldConfig, useLastValidHelocValues } from "./HelocCalculator.utils.esm.js";
import HelocFields from "./HelocFields.esm.js";
const HelocCalculator = ({
  defaultValues,
  editorMode
}) => /* @__PURE__ */ jsx(CalculatorForm, { fieldStorageKey: "helocFields", defaultValues: {
  [FieldConfig.homeValue.name]: 4e5,
  [FieldConfig.loanBalance.name]: 3e5,
  ...omitUndefined(defaultValues)
}, editorMode, children: /* @__PURE__ */ jsxs(Box, { css: {
  paddingBottom: "loose",
  display: "flex",
  flexDirection: "column"
}, children: [
  /* @__PURE__ */ jsx(HelocFields, {}),
  /* @__PURE__ */ jsxs(Box, { css: {
    textAlign: "center"
  }, children: [
    /* @__PURE__ */ jsx(Text, { textStyle: "heading-sm", asChild: true, children: /* @__PURE__ */ jsx("p", { children: "Estimated credit line*" }) }),
    /* @__PURE__ */ jsx(Text, { textStyle: "heading-sm", css: {
      color: "green.400",
      marginBottom: "default"
    }, asChild: true, children: /* @__PURE__ */ jsx("p", { title: "Estimated credit line", children: /* @__PURE__ */ jsx(CreditLine, {}) }) }),
    /* @__PURE__ */ jsx(Text, { textStyle: "body-xs", css: {
      marginBottom: "default"
    }, asChild: true, children: /* @__PURE__ */ jsx("p", { children: "*based on a 85% combined loan-to-value (CLTV) ratio" }) }),
    /* @__PURE__ */ jsx(Text, { textStyle: "body-xs", asChild: true, children: /* @__PURE__ */ jsx("p", { children: "The HELOC limit calculator is for informational purposes only and the estimates are based on information you provide. Actual available HELOC credit lines are subject to individual lender underwriting criteria and will depend on a number of factors, including CLTV ratios and property valuations. Zillow Group Marketplace, Inc. does not make loans and this is not a commitment to lend." }) })
  ] })
] }) });
const CreditLine = () => {
  const lastValidValues = useLastValidHelocValues();
  return `$${commaSeparateNumber(lastValidValues.calculations.creditLine)}`;
};
export {
  HelocCalculator as default
};
